import 'react-app-polyfill/ie11';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { overrideComponent, setOptions } from '@sheerid/jslib';
import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepFirstResponderPersonalInfoComponent } from './components/StepFirstResponderPersonalInfo/StepFirstResponderPersonalInfoComponent';
import { StepErrorComponent } from './components/StepErrorComponent';

setOptions(defaultOptions);
googleTagManagerHook();

// @ts-ignore
overrideComponent('StepFirstResponderPersonalInfoComponent', StepFirstResponderPersonalInfoComponent);
// @ts-ignore
overrideComponent('StepErrorComponent', StepErrorComponent);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
